import React, { useEffect, useState } from "react";
import axios from "axios";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import InvoiceComponent from "../Component/invoiceComponent";

function PdfGenerator() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `https://portal.fitstreak.club/api/api/users/pdfGenrator/${id}`
        );
        console.log("this is id from route", response.data);
        setUserData(response.data);
      } catch (err) {
        console.log("Failed to fetch user data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [id]);

  const downloadPDF = () => {
    const element = document.getElementById("invoice-container");

    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right in inches
      filename: "invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2, // Improves resolution
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf().set(opt).from(element).save();
  };

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray font-sans flex flex-col">
      <div className="w-full h-auto bg-white shadow-md z-50"></div>

      <div className="flex-grow flex flex-col mt-16 items-center py-8 px-4 justify-center">
        <div
          id="invoice-container"
          className="w-full max-w-4xl bg-white shadow-lg rounded-lg overflow-visible"
        >
          <InvoiceComponent plan={userData} month={userData.duration} />
        </div>

        <button
          onClick={downloadPDF}
          className="mt-6 px-6  py-3 bg-red text-white font-semibold rounded-md hover:bg-red transition-colors"
        >
          Download PDF
        </button>
      </div>
    </div>
  );
}

export default PdfGenerator;
